/*
 * Fil d'Ariane — chemin réellement parcouru.
 *
 * Le lien de collection posé par ciao-breadcrumbs.liquid est un choix
 * par défaut (la première collection du produit), pas forcément celle
 * par laquelle le client est passé. On corrige donc ce lien ici,
 * uniquement quand on peut déduire une collection du site depuis
 * document.referrer — sans jamais toucher à l'URL de la page elle-même
 * (le HTML servi et son URL canonique restent les mêmes pour le SEO).
 */
(function () {
  var lien = document.getElementById('CiaoBreadcrumbCollectionLien');
  if (!lien) return;

  function sansSlashFinal(chemin) {
    return (chemin || '').replace(/\/$/, '');
  }

  // Mémorisé par la page collection elle-même (voir
  // main-collection-product-grid.liquid) : disponible tout de suite,
  // sans requête réseau, donc aucun changement visible.
  var enMemoire = null;
  try {
    enMemoire = JSON.parse(sessionStorage.getItem('ciaoBreadcrumbCollection'));
  } catch (e) {}

  function appliquer(memo) {
    lien.href = memo.url;
    lien.textContent = memo.title;
  }

  // 1. Cas principal : le client vient de cliquer CE produit dans une
  //    grille de collection. Fiable même sans referrer (Safari, nouvel
  //    onglet, préfixe de langue /fr/ ou /en/, filtres, etc.).
  var handle = (lien.getAttribute('data-product-handle') || '').toLowerCase();
  if (enMemoire && enMemoire.url && enMemoire.title && handle && enMemoire.product === handle) {
    appliquer(enMemoire);
    return;
  }

  // 2. Sinon, on se fie à la page d'origine (document.referrer).
  var referrer;
  try {
    referrer = new URL(document.referrer);
  } catch (e) {
    return;
  }
  if (referrer.origin !== window.location.origin) return;

  // Accepte un préfixe de langue (/fr/collections/…, /en-ca/collections/…)
  // et un filtre par étiquette (/collections/<handle>/<tag>).
  var correspond = referrer.pathname.match(/^((?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[a-z0-9-]+)(?:\/[^\/]+)?\/?$/i);
  if (!correspond) return;
  var cheminCollection = correspond[1];
  if (/\/collections\/(vendors|types)$/i.test(cheminCollection)) return;

  if (enMemoire && enMemoire.url && sansSlashFinal(enMemoire.url) === sansSlashFinal(cheminCollection)) {
    appliquer(enMemoire);
    return;
  }

  // Repli (mémoire absente ou périmée, ex. première visite de la session
  // ou stockage vidé) : contrairement aux produits, Shopify n'expose pas
  // de /collections/<handle>.js — on va donc chercher le titre dans la
  // page HTML elle-même (balise og:title, toujours présente et déjà
  // dans la bonne casse, sans le nom de la boutique). Un court changement
  // visible reste possible dans ce cas précis, le temps de la requête.
  fetch(cheminCollection)
    .then(function (res) { return res.ok ? res.text() : null; })
    .then(function (html) {
      if (!html) return;
      var page = new DOMParser().parseFromString(html, 'text/html');
      var titre = page.querySelector('meta[property="og:title"]');
      if (!titre || !titre.content) return;
      lien.href = cheminCollection;
      lien.textContent = titre.content.trim().toLowerCase();
    })
    .catch(function () {});
})();
